import React, { useCallback, useState, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import HtmlTooltip from "../../components/HtmlToolTip/HtmlToolTip";
import { fetchAPIData, getCompanyId, getToken, getUser, generateHiddenColumns, copyToClipboard, hasPermission, usersManage } from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import Divider from '@mui/material/Divider';
import axios from 'axios';
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import { usePersistentStorage, clearPersistentStorage } from "../../Utils/usePersistentStorage";
import { useNavigate } from "react-router-dom";
import { closeSocket } from "../../components/Main/Main";
import "../pages.scss";
//import './system.scss';

const userSessionsSchema = require("../../json/userSessionsSchema.json").view;

const uiSchema = {
  "userInfo": {
    "ui:options": {
      widget: "textarea",
      rows: 7
    }
  }
};

const UserSessionsTabPanel = ({ setNotify }) => {
  const { permissions } = usePermissionContext();
  const [apiData, setApiData] = useState({});
  const [rowJsonData, setRowJsonData] = useState({});
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('view');  // default to view mode

  const [reload, setReload] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const [confirmProps, setConfirmProps] = useState({});
  const [isLoading, setIsloading] = useState(false);
  const [sessionRemoveyDialog, setSessionRemoveyDialog] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const [userSession, setUserSession] = usePersistentStorage("userSession", []);

  useEffect(() => {
    setApiData(userSession);
  }, []);

  const DEFAULT_COMPANY_ID = getCompanyId(); // make company dynamic

  const apiURL = `api/companies/${DEFAULT_COMPANY_ID}/users/session?`;

  const fieldData = [
    'userId'
  ];
  const hasUsersManage = hasPermission(permissions, usersManage);
  const filterOperators = [
    {
      label: 'EQUALS(=)',
      value: '='
    },
    {
      label: 'CONTAINS(%)',
      value: '%'
    }
  ];

  const sortFieldData = [
    // {
    //   field: 'companyId',
    //   label: 'Company ID'
    // },
    {
      field: 'userId',
      label: 'User ID'
    },
    {
      field: 'ttl',
      label: 'TTL'
    }
  ];

  const totalLabel = "Matching User Sessions";

  const getActionButtons = (params) => {
    let actionButtons = [];

    let deleteButton = <GridActionsCellItem icon={
      <Tooltip title="Delete user session" arrow placement="right">
        <DeleteIcon />
      </Tooltip>}
      label='Delete'
      onClick={deleteRowData(params.row)}
    />;

    hasUsersManage && actionButtons.push(deleteButton);

    return actionButtons;

  };

  const columns = [
    // {
    //   field: 'id',
    //   type: 'number',
    //   headerName: 'ID',
    //   hide: true,
    //   minWidth: 50,
    //   flex: 1,
    //   headerAlign: 'left',
    //   align: 'left',
    // },
    {
      hideable: false,
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      minWidth: 120,
      maxWidth: 120,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      getActions: (params) => getActionButtons(params)
    },
    {
      hideable: false,
      field: 'companyId',
      headerName: 'Company ID',
      type: 'number',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    },
    {
      hideable: false,
      field: 'userId',
      headerName: 'User ID',
      minWidth: 365,
      //maxWidth: 300,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      // renderCell: renderCellExpand,
      renderCell: (params) => {
        return (

          <div className="guidContent">
            <div style={{ width: '325px', overflow: "hidden", textOverflow: "ellipsis" }}>
              {params.value}
            </div>
            {params.value &&
              <div>
                <Tooltip title="Copy to clipboard" arrow placement="right">
                  <IconButton aria-label="copy user ID" onClick={(event) => copyToClipboard(event, params.row.userId)}>
                    <CopyIcon sx={{ fontSize: 'small' }} />
                  </IconButton>
                </Tooltip>
              </div>
            }
          </div>
        )
      }
    },
    {
      hideable: false,
      field: 'userName',
      headerName: 'User Name',
      minWidth: 200,
      //maxWidth: 300,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueGetter: (params) => {
        let userInfo = JSON.parse(params.row.userInfo);

        return (`${userInfo.userProfile.firstName || ''}_${userInfo.userProfile.lastName || ''}`);
      }
    },
    {
      hideable: false,
      field: 'sessionId',
      headerName: 'Session ID',
      minWidth: 375,
      //maxWidth: 300,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      hideable: false,
      field: 'ttl',
      headerName: 'TTL(s)',
      type: 'number',
      minWidth: 150,
      //maxWidth: 300,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      hideable: false,
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      //maxWidth: 300,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      field: 'userInfo',
      headerName: 'User Info',
      minWidth: 300,
      maxWidth: 300,
      hide: true,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {

        return (
          <>
            {params.row.userInfo && (
              <div>
                <p>
                  <HtmlTooltip followCursor placement="top" title={
                    <pre>
                      {JSON.stringify(JSON.parse(params.row.userInfo), null, 2)}
                    </pre>
                  }>
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                      {params.row.userInfo}
                    </div>

                  </HtmlTooltip>

                </p>
              </div>

            )}
          </>
        );
      }
    }


  ];

  const getColumns = () => {
    return (hasUsersManage && columns) || columns.filter(obj => { return obj.field !== "actions" });
  };

  const toggleColumnPinning = () => {
    return (hasUsersManage && 'columnPinning') || '';
  };

  const viewRowData = (param, event) => {

    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = param.row;

    setRowJsonData(JsonData);
    setMode('view');
    setOpen(true);
  };

  const fetchData = async (apiURL2, qparams) => {
    setIsloading(true);
    await fetchAPIData(apiURL2, qparams)
      .then((data) => {
        setApiData(data);
        setUserSession(data);
        // clear the reload false now that data is loaded
        setReload(false);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);

        let message = `Failed to load user sessions data \n\n ${err.response.statusText} : ${err.response.data.message}`;
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });

        setReload(false);
        setIsloading(false);
      });

  }

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  // handle click event of logout button
  const handleLogout = async (props) => {
    closeSocket();
    // clear all keys set in localstorage
    clearPersistentStorage();
    setTimeout(() => {
      navigate('/');
    }, 30000);
  };

  const deleteUserSession = (companyId, userId) => {
    let deleteUrl = `/api/companies/${companyId}/users/${userId}/session`;

    axios({
      method: "delete", url: deleteUrl,
      headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    })
      .then(response => {

        let message = `Deleted user session for ${userId}`;

        setNotify({
          isOpen: true,
          message: message,
          severity: 'info'
        });
        if (getUser() === userId) {
          // alert("Your session was removed from server, logging you off !!");
          document.getElementById('dialogLogout').showModal();
          setSessionRemoveyDialog(true);
          handleLogout();
        }
        // only reload if deleted user is not logged in user. Otherwise user no longer exists
        if (getUser() !== userId) {
          setApiData([]);
          setReload(true);
        }

      }).catch(error => {

        let message = `Failed to delete user session [${userId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });
      });
  };

  const deleteRowData = useCallback((rowData) => () => {

    let companyId = rowData.companyId;
    let userId = rowData.userId;
    let title = "Delete User Session";
    let confirmButtonText = "Yes";
    let cancelButtonText = "No";
    let msg = `The user session for ${userId} will be removed. Are you sure?`;

    let confirmProps = {
      title,
      msg,
      confirmButtonText,
      cancelButtonText,
      confirmCallback: () => deleteUserSession(companyId, userId)
    };

    setConfirmProps(confirmProps);

    setConfirmOpen(true);
  }, []);

  return (
    <>

      <div id="filterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
        <Filter permission={usersManage} fields={fieldData} filterOperators={filterOperators} sortFields={sortFieldData} apiURL={apiURL} fetchData={fetchData} useCompanyId={false} totalLabel={totalLabel} reload={reload} includeTotalDisplay={false} tabName={'userSessionsTab'} />
      </div>


      <Divider />

      <div id="userSessionsContainer" className={toggleColumnPinning()}>
        <div>
          <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
        </div>
      </div>

      {/* This dialog only support view. No need for form or save */}
      <ActionDialog
        open={open}
        mode={mode}
        onClose={handleClose}
        title={`User Sessions`}
        defaultTab='JSON'
        propertiesTabContent={
          <FormDialog
            formId={'userSessionsDialogId'}
            readOnly={true}
            schema={userSessionsSchema}
            uiSchema={uiSchema}
            formData={rowJsonData}
          />
        }
        jsonDataName={`user sessions`}
        JSONTabContent={rowJsonData}
      />

      <ConfirmDialog
        title={confirmProps.title}
        open={confirmOpen}
        onClose={handleConfirmClose}
        setOpen={setConfirmOpen}
        cancelButtonText={confirmProps.cancelButtonText}
        confirmButtonText={confirmProps.confirmButtonText}
        onConfirm={confirmProps.confirmCallback}
      >
        {confirmProps.msg}
      </ConfirmDialog>

      <dialog id="dialogLogout" open={sessionRemoveyDialog} className='sessionDialog'>
        <div>
          <p>Your session was removed from server, logging you off !!</p>
        </div>
      </dialog>
    </>
  );
}

export default UserSessionsTabPanel;